import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="recurrence-fields"
export default class extends Controller {
  static targets = ["frequency", "weekdays", "weekOfMonth", "recurrenceRange", "intervalUnit"];
  static values = { frequency: String };

  connect() {
    this.render(this.frequencyValue || this.frequencyTarget.value);
  }

  frequencyChanged(event) {
    this.render(event.target.value);
  }

  render(frequency) {
    const isRecurring = frequency !== "";
    this.recurrenceRangeTarget.classList.toggle("hidden", !isRecurring);
    this.recurrenceRangeTarget.classList.toggle("grid", isRecurring);
    this.weekdaysTarget.classList.toggle("hidden", frequency !== "weekly");
    this.weekOfMonthTarget.classList.toggle("hidden", frequency !== "monthly" && frequency !== "yearly");

    const units = { weekly: "week(en)", monthly: "maand(en)", yearly: "jaar" };
    this.intervalUnitTarget.textContent = units[frequency] || "";
  }
}
